import React, { useState } from 'react';
import FeedbackNonSelfLearningModalComponent from '../../Component/Modal/FeedbackNonSelfLearningModalComponent';
import { useMutation, useQuery } from '@tanstack/react-query';
import { contentManagementContentFeedbackAPI } from '../../../../../Services/ElearningContentManagement/contentFeedback';
import { toast } from 'react-toastify';
import ErrorHandler from '../../../../../App/ErrorHandler';

interface IProps {
  data: any;
  stage: any;
  submodule: any;
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedData: React.Dispatch<React.SetStateAction<any>>;
  handleRefresh: () => void;
  selectedData: any;
}

export default function FeedbackNonSelfLearningModalContainer({
  stage,
  submodule,
  showModal,
  setShowModal,
  selectedData,
  setSelectedData,
  handleRefresh,
}: IProps) {
  const [editMode, setEditMode] = useState(false);
  const [listFeedback, setListFeedback] = useState<any[]>([]);
  const [selectedFeedback, setSelectedFeedback] = useState([]);

  const {
    data: dataFeedbackBank,
    isLoading: isLoadingFeedback,
    isRefetching: isRefetchFeedback,
  } = useQuery(
    [
      'getContentManagementFeedbackBankByIdAPI',
      { id: submodule?.id, type: 'NonSelfLearning' },
    ],
    contentManagementContentFeedbackAPI.getFeedbackBankById,
    {
      enabled: submodule?.id !== undefined,
      refetchOnWindowFocus: false,
      onSuccess: res => {
        if (res) setListFeedback(res);
      },
    },
  );

  const initialValues: any = selectedData;

  const { mutate: mutateFeedback, isLoading: isLoadingSubmit } = useMutation(
    contentManagementContentFeedbackAPI.mutateFeedback,
    {
      onSuccess: () => {
        setShowModal(false);
        handleRefresh();
        toast.success(
          <span className="capitalFirst">Feedback Berhasil Ditambahkan!</span>,
        );
      },
      onError: (error: any) => {
        ErrorHandler(error);
      },
    },
  );

  const mutateFeedbackStatus = useMutation(
    contentManagementContentFeedbackAPI.mutateFeedbackStatus,
    {
      onSuccess: () => {
        setShowModal(false);
        handleRefresh();
        toast.success(
          <span className="capitalFirst">Feedback Berhasil Diupdate!</span>,
        );
      },
      onError: (error: any) => {
        ErrorHandler(error);
      },
    },
  );

  const handleCancel = () => {
    setSelectedData(undefined);
    setShowModal(false);
    setEditMode(false);
  };

  const handleResetQuestion = () => {
    setListFeedback(dataFeedbackBank ? dataFeedbackBank : []);
    setSelectedFeedback([]);
  };

  const onSubmit = (vals: any) => {
    if (selectedData) {
      if (editMode)
        mutateFeedbackStatus.mutate({
          status: vals.isActive,
          id: selectedData?.id,
        });
      else setEditMode(true);
    } else
      mutateFeedback({
        feedbacks: selectedFeedback,
        channelId: submodule.channelId,
        stageId: submodule.stageId,
        moduleId: submodule.moduleId,
        subModuleId: submodule.id,
        type: 'NonSelfLearning',
        codemiModuleId: stage.codemiUserLevelId,
      });
  };

  return (
    <FeedbackNonSelfLearningModalComponent
      disabled={false}
      isShow={showModal}
      handleCancel={handleCancel}
      handleResetQuestion={handleResetQuestion}
      handleSetListBank={setListFeedback}
      handleSetListSelected={setSelectedFeedback}
      onSubmit={onSubmit}
      initialValues={initialValues}
      modalAction={selectedData ? 'update' : 'register'}
      editMode={editMode}
      isLoading={isLoadingFeedback || isRefetchFeedback}
      listFeedback={listFeedback}
      selectedFeedback={selectedFeedback}
      isLoadingSubmit={isLoadingSubmit}
    />
  );
}
